/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from 'react';
import { getFilteredLibraryItems } from 'services/filtering';
import {
  TLengthRange,
  TSortOption,
  TTypeOption,
  TVoiceOption
} from 'services/libraryItem/interface';

export const useLibraryItems = (
  sortOption: TSortOption,
  lengthOption?: TLengthRange,
  voiceOption?: TVoiceOption,
  page = 0, // current page
  pageSize = 10,
  deviceLang?: string,
  contentLangs?: string,
  type?: TTypeOption | TTypeOption[],
  topic?: string,
  aiTags?: string[]
) => {
  const loadLibraryItems = useCallback(
    (offset: number) => {
      return getFilteredLibraryItems({
        voice_gender: voiceOption || undefined, // avoid sending empty string
        length_range: lengthOption,
        device_lang: deviceLang,
        content_langs: contentLangs?.split(','),
        content_types:
          (type && (Array.isArray(type) ? type : [type])) ||
          (deviceLang !== 'en' ? ['guided', 'talks'] : undefined),
        ...(aiTags ? {} : { topics: (topic && [topic]) || undefined }),
        sort_option: sortOption,
        size: pageSize,
        offset: pageSize * page + offset,
        ai_tags: aiTags
      });
    },
    [
      sortOption,
      lengthOption,
      voiceOption,
      page,
      deviceLang,
      contentLangs,
      type,
      topic
    ]
  );

  return loadLibraryItems;
};

export default useLibraryItems;
